/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import type { HTTPValidationError } from "./HTTPValidationError.ts";
import type { TokenLeaderboardResponse } from "./TokenLeaderboardResponse.ts";

export const getTokenLeaderboardV1StatsLeaderboardTokensGetQueryParamsNetworkEnum =
	{
		REGTEST: "REGTEST",
		MAINNET: "MAINNET",
	} as const;

export type GetTokenLeaderboardV1StatsLeaderboardTokensGetQueryParamsNetworkEnum =
	(typeof getTokenLeaderboardV1StatsLeaderboardTokensGetQueryParamsNetworkEnum)[keyof typeof getTokenLeaderboardV1StatsLeaderboardTokensGetQueryParamsNetworkEnum];

export type GetTokenLeaderboardV1StatsLeaderboardTokensGetQueryParams = {
	/**
	 * @type string
	 */
	network: GetTokenLeaderboardV1StatsLeaderboardTokensGetQueryParamsNetworkEnum;
	/**
	 * @minLength 1
	 * @maxLength 100
	 * @default 25
	 * @type integer | undefined
	 */
	limit?: number;
	/**
	 * @minLength 0
	 * @default 0
	 * @type integer | undefined
	 */
	offset?: number;
	/**
	 * @description Return only tokens whose updatedAt timestamp is after the given ISO timestamp.
	 * @type string, date-time
	 */
	afterUpdatedAt?: string | null;
};

/**
 * @description Successful Response
 */
export type GetTokenLeaderboardV1StatsLeaderboardTokensGet200 =
	TokenLeaderboardResponse;

/**
 * @description Validation Error
 */
export type GetTokenLeaderboardV1StatsLeaderboardTokensGet422 =
	HTTPValidationError;

export type GetTokenLeaderboardV1StatsLeaderboardTokensGetQueryResponse =
	GetTokenLeaderboardV1StatsLeaderboardTokensGet200;

export type GetTokenLeaderboardV1StatsLeaderboardTokensGetQuery = {
	Response: GetTokenLeaderboardV1StatsLeaderboardTokensGet200;
	QueryParams: GetTokenLeaderboardV1StatsLeaderboardTokensGetQueryParams;
	Errors: GetTokenLeaderboardV1StatsLeaderboardTokensGet422;
};
